import servicesUtils from "../../../utils/servicesUtils";
export var radReportDetailsQueryKey = function radReportDetailsQueryKey(patientUid, reportId) {
  return ["rad-report-details", patientUid, reportId];
};
export var radReportDetailsQueryOptions = function radReportDetailsQueryOptions(patientUid, reportId) {
  return {
    queryKey: radReportDetailsQueryKey(patientUid, reportId),
    queryFn: function queryFn() {
      return servicesUtils.getService("/patients/".concat(patientUid, "/image_study_rad_report/").concat(reportId, "/"));
    },
    enabled: !!patientUid && !!reportId
  };
};